(function () {
  async function addBundle(button) {
    if (button.dataset.loading === 'true') return;
    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;
    const original = button.textContent;
    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add bundle');
      window.location.assign(window.Shopify.routes.root + 'cart');
    } catch (error) {
      button.textContent = 'Try again';
      button.disabled = false;
      button.dataset.loading = 'false';
      return;
    }
    button.textContent = original;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ascend-bundle-add]');
    if (button) addBundle(button);
  });
})();
